import React from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { IconButton, IconButtonProps } from '@mui/material'
import { makeStyles } from '@mui/styles'
import classNames from 'classnames'

import i18n from '../../locales/i18n'
import { ClassesType } from '../../types'

const useStyles = makeStyles(
  theme => ({
    iconButton: {
      zIndex: theme.utils.modifyZIndex(theme.zIndex.base, 'above'),
      padding: 6,
      right: 10,
      top: 10,
      '&:hover': {
        backgroundColor: 'transparent',
      },
      position: 'absolute',
    },
    icon: {
      color: theme.colors.secondaryText,
      '&:hover': {
        opacity: '0.5',
      },
    },
    disabledIcon: {
      opacity: '0.5',
    },
  }),
  { name: 'PuiCloseButton' },
)

export interface PuiCloseButtonProps extends IconButtonProps {
  readonly classes?: ClassesType<typeof useStyles>
  readonly disabled?: boolean
}

const PuiCloseButton = ({
  classes: classesProp,
  disabled = false,
  ...rest
}: PuiCloseButtonProps) => {
  const classes = useStyles({ classes: classesProp, ...rest })

  return (
    <IconButton
      aria-label={i18n.t('Common:CLOSE_ACTION')}
      className={classes.iconButton}
      disabled={disabled}
      size="large"
      {...rest}
    >
      <CloseIcon
        className={classNames(classes.icon, {
          [classes.disabledIcon]: disabled,
        })}
      />
    </IconButton>
  )
}

export default PuiCloseButton
